export default __webpack_public_path__ + "static/the-coffee-club-46aee803b90873edb96a640950653fe9.jpeg";